// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"index_homeContent__HZn5P","desc":"index_desc__9XjKa"};